var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import { ArrowLeftOutlined, ArrowRightOutlined } from '@feb-team/legao-icons-react';
import { defaultProps } from './defaults';
import { DivTag, SpanTag, UlTag, LiTag } from '../../Utils/AtomicTag';
var DateYearPicker = /** @class */ (function (_super) {
    __extends(DateYearPicker, _super);
    function DateYearPicker(props) {
        var _this = _super.call(this, props) || this;
        _this.getYear = function (year) {
            return Array.from(Array(10), function (v, k) {
                return Number("" + String(year).substr(0, 3) + k);
            });
        };
        _this.getRangeYears = function (type) {
            var currYear = _this.state.currYear;
            var newCurrYear = Number(currYear) + (type === 'prev' ? -10 : 10);
            newCurrYear = newCurrYear < 100 ? 100 : newCurrYear;
            var newYears = Array.from(Array(10), function (v, k) {
                return Number("" + String(newCurrYear).substr(0, 3) + k);
            });
            _this.setState({
                currYear: newCurrYear,
                years: newYears,
            });
        };
        var year = _this.props.year;
        _this.state = {
            currYear: year,
            years: _this.getYear(year),
        };
        return _this;
    }
    DateYearPicker.prototype.render = function () {
        var _this = this;
        var contentCls = [
            'absolute',
            'font-sans',
            'top-0',
            'left-0',
            'bottom-0',
            'right-0',
            'bg-white',
            'flex',
            'flex-col',
        ];
        var wrapCls = ['flex', 'items-center', 'h-px-32', 'w-full', 'px-px-12'];
        var txtCls = ['flex-1', 'flex', 'h-px-32', 'items-center', 'justify-center'];
        var iconCls = ['h-px-32', 'px-px-2', 'py-px-5', 'mx-px-4', 'cursor-pointer'];
        var yearWrapCls = [
            'flex',
            'flex-1',
            'border-gray-200',
            'border-solid',
            'border-t',
            'items-center',
            'justify-center',
            'flex-wrap',
        ];
        var yearCls = [
            'p-px-5',
            'm-px-9',
            'w-px-60',
            'text-center',
            'rounded',
            'cursor-pointer',
        ];
        var yearActiveCls = ['text-white', 'bg-brand-600'];
        var _a = this.props, year = _a.year, updateYear = _a.updateYear;
        var _b = this.state, years = _b.years, currYear = _b.currYear;
        var yearPrefix = String(currYear).substr(0, 3);
        return (React.createElement(DivTag, { atomics: contentCls },
            React.createElement(DivTag, { atomics: wrapCls },
                React.createElement(SpanTag, { atomics: iconCls, onClick: function () { return _this.getRangeYears('prev'); } },
                    React.createElement(ArrowLeftOutlined, null),
                    React.createElement(ArrowLeftOutlined, { className: 'date-picker-header-prevIcon' })),
                React.createElement(SpanTag, { atomics: txtCls }, yearPrefix + "0-" + yearPrefix + "9"),
                React.createElement(SpanTag, { atomics: iconCls, onClick: function () { return _this.getRangeYears('next'); } },
                    React.createElement(ArrowRightOutlined, { className: 'date-picker-header-nextIcon' }),
                    React.createElement(ArrowRightOutlined, null))),
            React.createElement(UlTag, { atomics: yearWrapCls }, years.map(function (yearItem) {
                return (React.createElement(LiTag, { atomics: yearItem === year ? yearCls.concat(yearActiveCls) : yearCls, key: yearItem, onClick: function () { return updateYear(yearItem); } }, yearItem));
            }))));
    };
    DateYearPicker.defaultProps = defaultProps;
    DateYearPicker.NAME = 'date-year-picker';
    return DateYearPicker;
}(Component));
export { DateYearPicker };
